(() => {
  const FIXED_TIERS = [
    { threshold: 2, discount: 5 },
    { threshold: 3, discount: 10 },
    { threshold: 4, discount: 15 },
    { threshold: 5, discount: 20 }
  ];

  function parseConfig(sectionEl) {
    const sectionId = sectionEl.dataset.buildABoxSectionId;
    if (!sectionId) return null;

    const configEl = document.getElementById(`build-a-box-config-${sectionId}`);
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent);
    } catch (error) {
      console.error("Invalid Build a Box config JSON", error);
      return null;
    }
  }

  function formatCurrency(sectionEl, amount) {
    const currency =
      sectionEl.querySelector("#summary-total")?.dataset.currency || "USD";

    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency
    }).format(amount);
  }

  function getApplicableTier(totalQty) {
    let tier = null;
    for (let i = 0; i < FIXED_TIERS.length; i += 1) {
      if (totalQty >= FIXED_TIERS[i].threshold) {
        tier = FIXED_TIERS[i];
      }
    }
    return tier;
  }

  function getSelectedItems(sectionEl) {
    const items = [];
    const selected = sectionEl.querySelectorAll(".box-product-checkbox:checked");

    selected.forEach((checkbox) => {
      const productEl = checkbox.closest(".box-product");
      if (!productEl) return;

      const qtyInput = productEl.querySelector(".qty-input");
      const quantity = Number.parseInt(qtyInput?.value || "0", 10);
      const id = String(productEl.dataset.variantId || "");
      const price = Number.parseInt(productEl.dataset.price || "0", 10);

      if (!id || quantity <= 0) return;

      items.push({ id, quantity, price });
    });

    return items;
  }

  function getBundleTotals(items, freeGiftVariantId) {
    let subtotalCents = 0;
    let totalQty = 0;

    items.forEach((item) => {
      subtotalCents += (item.price || 0) * item.quantity;
      if (!freeGiftVariantId || String(item.id) !== String(freeGiftVariantId)) {
        totalQty += item.quantity;
      }
    });

    return { subtotalCents, totalQty };
  }

  function getFinalItems(sectionEl, config) {
    const freeGiftVariantId = String(config?.freeGiftVariantId || "");
    const baseThresholdUsdCents = Number(config?.freeGiftThresholdUsdCents || 0);
    const rate = window.Shopify?.currency?.rate || 1;
    const freeThreshold = Math.round(baseThresholdUsdCents * rate);

    const items = getSelectedItems(sectionEl);
    const { subtotalCents } = getBundleTotals(items, freeGiftVariantId);

    if (!freeGiftVariantId || freeThreshold <= 0) {
      return items;
    }

    const freeIndex = items.findIndex(
      (item) => String(item.id) === freeGiftVariantId
    );

    if (subtotalCents >= freeThreshold && freeIndex === -1) {
      items.push({ id: freeGiftVariantId, quantity: 1, price: 0 });
    }

    if (subtotalCents < freeThreshold && freeIndex !== -1) {
      items.splice(freeIndex, 1);
    }

    return items;
  }

  function updateProgressBar(sectionEl, totalQty) {
    const totalItemsEl = sectionEl.querySelector("#total-items");
    const progressEl = sectionEl.querySelector("#discount-progress");
    const textEl = sectionEl.querySelector("#progress-text");
    if (!totalItemsEl || !progressEl || !textEl) return;

    totalItemsEl.textContent = String(totalQty);

    const applicable = getApplicableTier(totalQty);
    const nextTier = FIXED_TIERS.find((tier) => totalQty < tier.threshold) || null;

    let percent = 0;

    if (nextTier) {
      const prevThreshold = applicable?.threshold || 0;
      const tierWindow = nextTier.threshold - prevThreshold;
      const progressInTier = totalQty - prevThreshold;
      percent = tierWindow > 0 ? (progressInTier / tierWindow) * 100 : 0;

      const remainingQty = nextTier.threshold - totalQty;
      textEl.textContent = `Add ${remainingQty} product${remainingQty !== 1 ? "s" : ""} more to get ${nextTier.discount}% discount!`;
    } else {
      percent = 100;
      textEl.textContent = "Congratulations! You have gotten the best offer on your bundle!";
    }

    progressEl.style.width = `${Math.min(Math.max(percent, 0), 100)}%`;
  }

  function resolveDiscountCode(applicableTier, config) {
    if (!applicableTier) return "";

    const byThreshold = config?.discountCodesByThreshold || {};
    const byDiscount = config?.discountCodesByDiscount || {};

    return (
      byThreshold[String(applicableTier.threshold)] ||
      byDiscount[String(applicableTier.discount)] ||
      ""
    );
  }

  function updateSummary(sectionEl, items, config) {
    const listEl = sectionEl.querySelector("#summary-items");
    const totalEl = sectionEl.querySelector("#summary-total");
    if (!listEl || !totalEl) return;

    listEl.innerHTML = "";

    const freeGiftVariantId = String(config?.freeGiftVariantId || "");

    let discountedTotalCents = 0;

    items.forEach((item) => {
      if (freeGiftVariantId && String(item.id) === freeGiftVariantId) return;

      const productEl = sectionEl.querySelector(
        `.box-product[data-variant-id="${item.id}"]`
      );
      if (!productEl) return;

      const inputEl = productEl.querySelector("input.box-product-checkbox");
      const title = inputEl?.dataset.title || "";
      const img = inputEl?.dataset.img || "";

      const lineTier = getApplicableTier(item.quantity);
      const lineDiscountRate = (lineTier?.discount || 0) / 100;
      const baseLineTotalCents = (item.price || 0) * item.quantity;
      const discountedLineTotalCents = Math.round(
        baseLineTotalCents * (1 - lineDiscountRate)
      );
      discountedTotalCents += discountedLineTotalCents;

      listEl.insertAdjacentHTML(
        "beforeend",
        `
          <li>
            <span class="img-wrap"><img src="${img}" alt="${title}"></span>
            <span class="prod-info-wrap"><span class="prod-title">${title}</span>
            <span class="prod-info">${formatCurrency(sectionEl, discountedLineTotalCents / 100)} x ${item.quantity}</span>
            </span>
            <button class="remove-btn" data-title="${title}">×</button>
          </li>
        `
      );
    });

    const freeGiftItem = items.find(
      (item) => freeGiftVariantId && String(item.id) === freeGiftVariantId
    );

    if (freeGiftItem) {
      const giftTitle = config?.freeGiftTitle || "";
      const giftImg = config?.freeGiftImage || "";
      listEl.insertAdjacentHTML(
        "beforeend",
        `
          <li>
            <span class="img-wrap"><img src="${giftImg}" alt="${giftTitle}"></span>
            <span class="prod-info-wrap"><span class="prod-title">${giftTitle}</span>
            <span class="prod-info">FREE</span>
            </span>
          </li>
        `
      );
    }

    totalEl.textContent = formatCurrency(sectionEl, discountedTotalCents / 100);
  }

  function refresh(sectionEl, config) {
    const items = getFinalItems(sectionEl, config);
    const freeGiftVariantId = String(config?.freeGiftVariantId || "");
    const { totalQty } = getBundleTotals(items, freeGiftVariantId);

    updateProgressBar(sectionEl, totalQty);
    updateSummary(sectionEl, items, config);
  }

  function initSection(sectionEl) {
    const config = parseConfig(sectionEl) || {};

    sectionEl.querySelectorAll(".box-product-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        const wrapper = checkbox.closest(".box-product")?.querySelector(".quantity-wrapper");
        if (!wrapper) return;

        wrapper.style.display = checkbox.checked ? "block" : "none";
        if (checkbox.checked) {
          wrapper.classList.add("active");
        } else {
          wrapper.classList.remove("active");
        }

        refresh(sectionEl, config);
      });
    });

    sectionEl.querySelectorAll(".qty-minus").forEach((button) => {
      button.addEventListener("click", () => {
        const wrapper = button.closest(".quantity-wrapper");
        const productEl = button.closest(".box-product");
        const input = wrapper?.querySelector(".qty-input");
        const checkbox = productEl?.querySelector(".box-product-checkbox");
        if (!wrapper || !input || !checkbox) return;

        const newVal = Number.parseInt(input.value || "1", 10) - 1;
        if (newVal <= 0) {
          checkbox.checked = false;
          input.value = "1";
          wrapper.style.display = "none";
          wrapper.classList.remove("active");
        } else {
          input.value = String(newVal);
        }

        refresh(sectionEl, config);
      });
    });

    sectionEl.querySelectorAll(".qty-plus").forEach((button) => {
      button.addEventListener("click", () => {
        const wrapper = button.closest(".quantity-wrapper");
        const input = wrapper?.querySelector(".qty-input");
        if (!input) return;

        input.value = String(Number.parseInt(input.value || "1", 10) + 1);
        refresh(sectionEl, config);
      });
    });

    const summaryEl = sectionEl.querySelector("#summary-items");
    summaryEl?.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.matches(".remove-btn")) return;

      const title = target.getAttribute("data-title") || "";
      const sourceInput = sectionEl.querySelector(
        `.box-product-checkbox[data-title="${CSS.escape(title)}"]`
      );
      const productEl = sourceInput?.closest(".box-product");
      const qtyInput = productEl?.querySelector(".qty-input");
      const wrapper = qtyInput?.closest(".quantity-wrapper");
      if (!sourceInput || !qtyInput || !wrapper) return;

      sourceInput.checked = false;
      qtyInput.value = "1";
      wrapper.style.display = "none";
      wrapper.classList.remove("active");
      refresh(sectionEl, config);
    });

    const formEl = sectionEl.querySelector("#bundle-form");
    formEl?.addEventListener("submit", (event) => {
      event.preventDefault();

      const items = getFinalItems(sectionEl, config);
      const freeGiftVariantId = String(config?.freeGiftVariantId || "");
      const purchasableItems = items.filter(
        (item) => !freeGiftVariantId || String(item.id) !== freeGiftVariantId
      );

      if (purchasableItems.length === 0) {
        alert("Please select at least one product.");
        return;
      }

      fetch("/cart/clear.js", { method: "POST" })
        .then(() =>
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items })
          })
        )
        .then(() => {
          const { totalQty } = getBundleTotals(items, freeGiftVariantId);
          const applicableTier = getApplicableTier(totalQty);
          const discountCode = resolveDiscountCode(applicableTier, config);

          const checkoutUrl = discountCode
            ? `/checkout?discount=${encodeURIComponent(discountCode)}`
            : "/checkout";

          window.location.href = checkoutUrl;
        })
        .catch((error) => {
          console.error("Error adding bundle to cart:", error);
          alert("Something went wrong. Please try again.");
        });
    });

    window.addEventListener("pageshow", () => {
      sectionEl.querySelectorAll(".box-product-checkbox").forEach((checkbox) => {
        checkbox.checked = false;
        const wrapper = checkbox.closest(".box-product")?.querySelector(".quantity-wrapper");
        if (!wrapper) return;

        wrapper.style.display = "none";
        wrapper.classList.remove("active");
      });

      sectionEl.querySelectorAll(".qty-input").forEach((input) => {
        input.value = "1";
      });

      const summaryItemsEl = sectionEl.querySelector("#summary-items");
      const summaryTotalEl = sectionEl.querySelector("#summary-total");
      const progressEl = sectionEl.querySelector("#discount-progress");
      const progressTextEl = sectionEl.querySelector("#progress-text");
      const totalItemsEl = sectionEl.querySelector("#total-items");

      if (summaryItemsEl) summaryItemsEl.innerHTML = "";
      if (summaryTotalEl) summaryTotalEl.textContent = formatCurrency(sectionEl, 0);
      if (progressEl) progressEl.style.width = "0%";
      if (progressTextEl) progressTextEl.textContent = "";
      if (totalItemsEl) totalItemsEl.textContent = "0";
    });

    refresh(sectionEl, config);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll('.section--build-a-box[data-build-a-box-section-id]')
      .forEach((sectionEl) => initSection(sectionEl));
  });
})();